import { useEffect, useState } from 'react'
import { ProductJsonData, ProductNative } from '../../search-spring/types/types'
import { getRecentlyHandleProducts } from '../../helpers/productRecently'
import { LoaderSpin } from '../../wishlist/components/LoaderSpin'
import useWindowSize from '../../search-spring/customHooks/useWindowSize'
import ProductCarousel from '../../product-carousel/components/ProductCarousel'

type Props = {
  productJsonData: ProductJsonData
}

declare global {
  interface Window {
    recentyViewedCarouselHeading: string
    Shopify: {
      routes: {
        root: string
      }
    }
  }
}

const carouselHeading = window?.recentyViewedCarouselHeading || 'Recently Viewed'

const RecentlyViewedCarouselInit = ({ productJsonData }: Props) => {
  const [products, setProducts] = useState<ProductNative[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const windowSize = useWindowSize()
  const isMediumTablet = windowSize.width >= 1024
  const isDesktop = windowSize.width >= 1024

  if (!productJsonData?.product) {
    return <></>
  }

  const recentlyHandles = getRecentlyHandleProducts().filter((i) => i !== productJsonData.product.handle)

  const fetchProducts = async (handles: string[]) => {
    const allFetches = handles.map(async (handle) => {
      try {
        const response = await fetch(`${window.Shopify.routes.root}products/${handle}?view=ajax`)

        if (!response.ok) {
          console.error(`Fetch failed for ${handle}:`, response.statusText)
          return null
        }

        const product = await response.json()
        return product
      } catch (error) {
        console.error(`Error fetching product ${handle}:`, error)
        return null
      }
    })

    return Promise.all(allFetches).then((results) => {
      return results.filter((result) => result !== null)
    })
  }

  const getProductData = async () => {
    setIsLoading(true)
    try {
      const products = await fetchProducts(recentlyHandles)
      const dataProducts = products.filter((product) => product)
      if (dataProducts.length) {
        setProducts(dataProducts)
      }
    } catch (error) {
      setIsLoading(false)
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (recentlyHandles.length) {
      getProductData()
    }
  }, [])

  if (isLoading) {
    return (
      <div className="relative h-10 w-full py-10 md:py-2XL">
        <LoaderSpin />
      </div>
    )
  }

  if (isError) {
    return <div className="text-xl font-bstSpyre mt-4 text-center mx-5">Sorry, There was an error creating our carousels, please try again later.</div>
  }

  return (
    <>
      {products.length > 0 && !isLoading && (
        <div className="py-10 w-full mx-auto md:px-5 md:py-2XL md:flex md:flex-col">
          <h2 className="font-bstSpyre text-2xl uppercase text-center mb-LG md:mb-DLG">{carouselHeading}</h2>
          <ProductCarousel
            classSlider="md-max:w-[230px] md:min-h-[491px]"
            products={products}
            source="native"
            spaceBetween={0}
            slidesPerView="auto"
            breakpoints={{
              768: { slidesPerView: 3, spaceBetween: 5 },
              1024: { slidesPerView: 4, spaceBetween: 5 }
            }}
          />
        </div>
      )}
    </>
  )
}

export default RecentlyViewedCarouselInit
